/** Wash / sale payment status helpers */

export function normalizeWashPaymentStatus(status) {
  return String(status || 'unpaid').toLowerCase()
}

export function washPaymentLabel(wash) {
  const ps = normalizeWashPaymentStatus(wash?.paymentStatus)
  if (ps === 'paid') return 'Paid'
  if (ps === 'on_account') return 'On account'
  return 'Unpaid'
}

/** Customer may collect vehicle without immediate cashier payment */
export function washAllowsPickup(wash) {
  const ps = normalizeWashPaymentStatus(wash?.paymentStatus)
  return ps === 'paid' || ps === 'on_account'
}

/** Still needs payment at Manual POS */
export function washNeedsCashierPayment(wash) {
  return normalizeWashPaymentStatus(wash?.paymentStatus) === 'unpaid'
}

export function washPaymentBadgeClass(wash) {
  const ps = normalizeWashPaymentStatus(wash?.paymentStatus)
  if (ps === 'paid') return 'text-green-600'
  if (ps === 'on_account') return 'text-amber-700'
  return 'text-red-600'
}
